import { IDirectorySearchParams, SearchParamActionTypes } from "./types";

export type SearchParamAction = {
    type: SearchParamActionTypes;
    payload: Partial<IDirectorySearchParams>;
};

export const setDirectorySearchParams = (
    params: Partial<IDirectorySearchParams>
): SearchParamAction => ({
    type: SearchParamActionTypes.SET_SEARCH_PARAM,
    payload: params,
});
